export default __webpack_public_path__ + "b76732e59d2e804165853217de14aab6.woff2";